import React from 'react'

const Spacer = ({ height = "1rem", border = "border-t", color = "border-gray-300", margin = "m-0", padding = "p-0" }) => {
  return (
    <div
      className={`${border} ${color} ${margin} ${padding}`}
      style={{ height }}
    />
  )
}

export default Spacer